import { Box, Typography } from '@mui/material'
import { SearchOff as SearchOffIcon } from '@mui/icons-material'

interface EmptyStateProps {
  title?: string
  message?: string
}

const EmptyState = ({
  title = 'No Load Found',
  message = 'No load number detected in this conversation'
}: EmptyStateProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 200,
        py: 6,
        px: 3,
        textAlign: 'center'
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          bgcolor: 'grey.100',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2
        }}
      >
        <SearchOffIcon sx={{ fontSize: 32, color: 'grey.400' }} />
      </Box>
      <Typography
        variant="subtitle1"
        color="text.primary"
        sx={{ fontWeight: 600, mb: 0.5 }}
      >
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 240 }}>
        {message}
      </Typography>
    </Box>
  )
}

export default EmptyState
